import {
  Directive,
  HostListener,
  Input,
} from '@angular/core';
import { FormGroup } from '@angular/forms';


@Directive({
  selector: '[laasFullToHalf]',
})
export class FullToHalfDirective {
  @Input() fullToHalfObj: any | undefined;

  constructor() {}

  @HostListener('document:keyup', ['$event'])
  @HostListener('document:mousedown', ['$event'])
  onInputChange(event: Event): void {

    if (typeof this.fullToHalfObj !== 'object' || this.fullToHalfObj === null) {
      return;
    }
    // console.log('fullToHalfObj orgin = ', this.fullToHalfObj);
    for (const key in this.fullToHalfObj) {
      if (this.isFormGroup(this.fullToHalfObj[key])) {
        const formGroupValue = this.fullToHalfObj[key].value;
        if (formGroupValue === null) continue;
        this.convertObjectFullToHalf(formGroupValue);
      }else{
        const innerObj = this.fullToHalfObj[key];
        this.convertObjectFullToHalf(innerObj);
      }
    }
    // console.log('fullToHalfObj change = ', this.fullToHalfObj);
  }

  isFormGroup(obj: any): obj is FormGroup {
    return obj instanceof FormGroup;
  }

  convertObjectFullToHalf(obj: any): void {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] === null) continue;
        if (typeof obj[key] === 'string') {
          obj[key] = this.fullToHalf(obj[key]);
        } else if (Array.isArray(obj[key])) {
          this.convertArrayFullToHalf(obj[key]);
        } else if (typeof obj[key] === 'object') {
          this.convertObjectFullToHalf(obj[key]);
        }
      }
    }
  }

  convertArrayFullToHalf(arr: any[]): void {
    for (let i = 0; i < arr.length; i++) {
      if (typeof arr[i] === 'string') {
        arr[i] = this.fullToHalf(arr[i]);
      } else if (Array.isArray(arr[i])) {
        this.convertArrayFullToHalf(arr[i]);
      } else if (typeof arr[i] === 'object') {
        this.convertObjectFullToHalf(arr[i]);
      }
    }
  }

  fullToHalf(str: string): string {
    if (!str) return str;
    return str
      .replace(
        /[\uff01-\uff5e]/g,
        (
          ch //概括全形符號&英數字(但沒有空格)
        ) => String.fromCharCode(ch.charCodeAt(0) - 0xfee0) //半形 = 全形 - 0xfee0
      )
      .replace(/\u3000/g, ' '); //replace(/\u3000/g, ' ') 處理全形的空格
  }
}
